import React from "react";
import UserContext from "../../context/user-context";
import { UserActions } from "../../store/actions/userAction";
import {UserState} from "../../passapp-sdk/types/userTypes";

type UserProviderProps = {
  state: UserState;
  dispatch: React.Dispatch<UserActions>;
  children?: React.ReactNode;
};

const UserProvider = ({ state, children, dispatch }: UserProviderProps) => {
  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
